export default function getExistingLayer(layers, name) {
    var found = null;
    $(layers).each(function (i, key){
        var lname = key.get("name");
        //if (mapConfiguration.debug) console.log("getExistingLayer - Vrstva " + i + " se jmenuje", lname);
        if (lname == name) found = key;
    });
    return found;
}
